import { FunctionComponent, ReactNode } from 'react';
import { Box } from '@mui/material';

const SpacingMap = {
	lg: 2,
	lgHalf: 1.5,
	md: 1,
	none: 0,
	sm: 0.5,
	xLg: 3,
};

type Spacing = keyof typeof SpacingMap;
interface IPageWrapper {
	children: ReactNode;
	spacing?: Spacing;
}

export const PageWrapper: FunctionComponent<IPageWrapper> = ({ children, spacing = 'none' }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
				minHeight: 0,
				overflow: 'auto',
				gap: SpacingMap[spacing],
			}}
		>
			{children}
		</Box>
	);
};
